var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGridVertical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5332 25.5547C8.5332 26.107 8.98092 26.5547 9.5332 26.5547L17.3618 26.5547C17.9141 26.5547 18.3618 26.107 18.3618 25.5547L18.3618 14.4499C18.3618 13.8976 17.9141 13.4499 17.3618 13.4499L9.5332 13.4499C8.98092 13.4499 8.5332 13.8976 8.5332 14.4499L8.5332 25.5547ZM21.638 25.5547C21.638 26.107 22.0857 26.5547 22.638 26.5547L30.4665 26.5547C31.0188 26.5547 31.4665 26.107 31.4665 25.5547L31.4665 14.4499C31.4665 13.8976 31.0188 13.4499 30.4665 13.4499L22.638 13.4499C22.0857 13.4499 21.638 13.8976 21.638 14.4499L21.638 25.5547Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGridVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_grid_vertical.1e25d13a13f6e5ba06b90a7d1f76aed8.svg";